export function affiliateDealsActiveDateFilter(): string {
    const now = Math.floor(Date.now() / 1000);
    return `filters[starts_at_lt]=${now}&filters[ends_at_gt]=${now}`;
}
